import { useQuery } from "@tanstack/react-query";
import { API_ROOMS } from "../apis";
import { QUERY_KEY } from "../keys";

export const useGetRoom = <T>(params: { [key: string]: string }, options = {}) => {
    const { data, isLoading, refetch } = useQuery({
        queryKey: [QUERY_KEY.GET_ROOM_INFO, params],
        queryFn: () => API_ROOMS.getRoomInfo<T>(params),
        ...options,
    });

    return { data, isLoading, refetch };
};
